import { render, staticRenderFns } from "./JoaBusinesStripList.vue?vue&type=template&id=8ca1165e&scoped=true&"
import script from "./JoaBusinesStripList.vue?vue&type=script&lang=js&"
export * from "./JoaBusinesStripList.vue?vue&type=script&lang=js&"
import style0 from "./JoaBusinesStripList.vue?vue&type=style&index=0&id=8ca1165e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca1165e",
  null
  
)

export default component.exports